import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin } from '@zillow/constellation';

export const StyledFlexPriceOnlyContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  order: -1;

  ${mediaMixin(
    'lg',
    css`
      justify-content: flex-end;
      order: 1;
      margin-right: ${spaceMixin('sm')};
    `,
  )}
`;

export const StyledMobileOnlyVerticalDivider = styled.div`
  background-color: #ccc;
  display: flex;
  height: 10px;
  margin: 0 ${spaceMixin('xs')};
  width: 1px;

  ${mediaMixin(
    'lg',
    css`
      display: none;
    `,
  )}
`;
